/**
 * @generated SignedSource<<1cbbe8fe945819125165e94d2a01b422>>
 * @relayHash b652a5e40409479f7be8322054cb2ab0
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8a8bd9b4f8d1227e47fead7f36416f5a7665f2a9b83f9f1c4430df2cc6e74a88

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HomeScreenQuery$variables = {
  highlightedGuildSlug: string;
};
export type HomeScreenQuery$data = {
  readonly viewer: {
    readonly id: string;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"UnauthenticatedHomeScreen_query">;
};
export type HomeScreenQuery = {
  response: HomeScreenQuery$data;
  variables: HomeScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "highlightedGuildSlug"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": [
    "CREATED_AT_DESC",
    "ID_ASC"
  ]
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prettyUrl",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v6 = {
  "kind": "Literal",
  "name": "path",
  "value": "home-page/event-hero.png"
},
v7 = {
  "kind": "Literal",
  "name": "transform",
  "value": {
    "dpr": 3,
    "fo": "face",
    "h": 80,
    "w": 80
  }
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "websiteUrl",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "twitterUrl",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "instagramUrl",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkedinUrl",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "youtubeUrl",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "githubUrl",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blueskyUrl",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blueskyIdentifier",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "membershipLevel",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "GuildMembership",
  "kind": "LinkedField",
  "name": "myMembership",
  "plural": false,
  "selections": [
    (v22/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberCount",
  "storageKey": null
},
v25 = {
  "kind": "Literal",
  "name": "dpr",
  "value": 3
},
v26 = {
  "kind": "Literal",
  "name": "fit",
  "value": "cover"
},
v27 = {
  "kind": "Literal",
  "name": "h",
  "value": 100
},
v28 = {
  "kind": "Literal",
  "name": "w",
  "value": 100
},
v29 = {
  "alias": null,
  "args": [
    {
      "fields": [
        (v25/*: any*/),
        (v26/*: any*/),
        (v27/*: any*/),
        (v28/*: any*/)
      ],
      "kind": "ObjectValue",
      "name": "transform"
    }
  ],
  "kind": "ScalarField",
  "name": "transformUrl",
  "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"h\":100,\"w\":100})"
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "colorPalette",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryPhoto",
  "plural": false,
  "selections": [
    (v29/*: any*/),
    (v30/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "backgroundPhoto",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "transform",
          "value": {
            "dpr": 3,
            "fit": "cover",
            "h": 200,
            "w": 500
          }
        }
      ],
      "kind": "ScalarField",
      "name": "transformUrl",
      "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"h\":200,\"w\":500})"
    },
    (v1/*: any*/)
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "transform",
      "value": {
        "dpr": 3,
        "h": 200,
        "w": 500
      }
    }
  ],
  "kind": "ScalarField",
  "name": "defaultBackgroundUrl",
  "storageKey": "defaultBackgroundUrl(transform:{\"dpr\":3,\"h\":200,\"w\":500})"
},
v34 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v35 = {
  "kind": "Literal",
  "name": "timeSelection",
  "value": "UPCOMING"
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailMd5",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryPhoto",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            (v25/*: any*/),
            (v26/*: any*/),
            {
              "kind": "Literal",
              "name": "fo",
              "value": "face"
            },
            (v27/*: any*/),
            (v28/*: any*/)
          ],
          "kind": "ObjectValue",
          "name": "transform"
        }
      ],
      "kind": "ScalarField",
      "name": "transformUrl",
      "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"fo\":\"face\",\"h\":100,\"w\":100})"
    },
    (v1/*: any*/)
  ],
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": [
    {
      "fields": [
        (v25/*: any*/),
        (v27/*: any*/),
        (v28/*: any*/)
      ],
      "kind": "ObjectValue",
      "name": "transform"
    }
  ],
  "kind": "ScalarField",
  "name": "defaultAvatarUrl",
  "storageKey": "defaultAvatarUrl(transform:{\"dpr\":3,\"h\":100,\"w\":100})"
},
v41 = {
  "kind": "InlineFragment",
  "selections": (v2/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v43 = [
  (v36/*: any*/),
  (v37/*: any*/),
  (v9/*: any*/),
  (v38/*: any*/),
  (v39/*: any*/),
  (v40/*: any*/),
  (v1/*: any*/)
],
v44 = [
  (v42/*: any*/)
],
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v46 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": [
    "CREATED_AT_ASC",
    "ID_ASC"
  ]
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "presenterFirstName",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "presenterLastName",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "presenter",
  "plural": false,
  "selections": (v43/*: any*/),
  "storageKey": null
},
v51 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "EventsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startAt",
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasExternalUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasVenue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "visibility",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "coverPhoto",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v1/*: any*/),
              {
                "alias": "mobileTransformUrl",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "transform",
                    "value": {
                      "dpr": 3,
                      "w": 576
                    }
                  }
                ],
                "kind": "ScalarField",
                "name": "transformUrl",
                "storageKey": "transformUrl(transform:{\"dpr\":3,\"w\":576})"
              },
              {
                "alias": "desktopTransformUrl",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "transform",
                    "value": {
                      "dpr": 3,
                      "w": 200
                    }
                  }
                ],
                "kind": "ScalarField",
                "name": "transformUrl",
                "storageKey": "transformUrl(transform:{\"dpr\":3,\"w\":200})"
              }
            ],
            "storageKey": null
          },
          {
            "alias": "eventOwner",
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v11/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "primaryPhoto",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v1/*: any*/),
                      (v29/*: any*/),
                      (v30/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GuildMembership",
                    "kind": "LinkedField",
                    "name": "myMembership",
                    "plural": false,
                    "selections": [
                      (v22/*: any*/),
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "type": "Guild",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v36/*: any*/),
                  (v37/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isMe",
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  (v38/*: any*/),
                  (v39/*: any*/),
                  (v40/*: any*/)
                ],
                "type": "User",
                "abstractKey": null
              },
              (v41/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "attendeesByRelevance",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "status": {
                    "in": [
                      "ATTENDING_IN_PERSON",
                      "ATTENDING_VIRTUAL",
                      "WAITING_IN_PERSON",
                      "WAITING_VIRTUAL"
                    ]
                  }
                }
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 8
              }
            ],
            "concreteType": "EventAttendeesConnection",
            "kind": "LinkedField",
            "name": "eventAttendeesByRelevance",
            "plural": false,
            "selections": [
              (v42/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "EventAttendeesEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventAttendee",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": (v43/*: any*/),
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "eventAttendeesByRelevance(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\",\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}},first:8)"
          },
          {
            "alias": "attendingCount",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "status": {
                    "in": [
                      "ATTENDING_IN_PERSON",
                      "ATTENDING_VIRTUAL"
                    ]
                  }
                }
              }
            ],
            "concreteType": "EventAttendeesConnection",
            "kind": "LinkedField",
            "name": "eventAttendees",
            "plural": false,
            "selections": (v44/*: any*/),
            "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\"]}})"
          },
          {
            "alias": "waitingCount",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "status": {
                    "in": [
                      "WAITING_IN_PERSON",
                      "WAITING_VIRTUAL"
                    ]
                  }
                }
              }
            ],
            "concreteType": "EventAttendeesConnection",
            "kind": "LinkedField",
            "name": "eventAttendees",
            "plural": false,
            "selections": (v44/*: any*/),
            "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}})"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": [
                  "SORT_ORDER_ASC",
                  "CREATED_AT_ASC"
                ]
              }
            ],
            "concreteType": "EventTicketingTiersConnection",
            "kind": "LinkedField",
            "name": "eventTicketingTiers",
            "plural": false,
            "selections": (v44/*: any*/),
            "storageKey": "eventTicketingTiers(orderBy:[\"SORT_ORDER_ASC\",\"CREATED_AT_ASC\"])"
          },
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EventAttendee",
            "kind": "LinkedField",
            "name": "myAttendance",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "visibleStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "paymentStatus",
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v10/*: any*/),
                  (v23/*: any*/)
                ],
                "type": "Guild",
                "abstractKey": null
              },
              (v41/*: any*/)
            ],
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Form",
            "kind": "LinkedField",
            "name": "attendeeForm",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          (v45/*: any*/),
          {
            "alias": "eventItemPresentations",
            "args": [
              (v46/*: any*/)
            ],
            "concreteType": "PresentationsConnection",
            "kind": "LinkedField",
            "name": "presentations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PresentationsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Presentation",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v47/*: any*/),
                      (v9/*: any*/),
                      (v48/*: any*/),
                      (v49/*: any*/),
                      (v50/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "transform",
                            "value": {
                              "dpr": 3,
                              "h": 24,
                              "w": 24
                            }
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "guestPresenterAvatarUrl",
                        "storageKey": "guestPresenterAvatarUrl(transform:{\"dpr\":3,\"h\":24,\"w\":24})"
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "presentations(orderBy:[\"CREATED_AT_ASC\",\"ID_ASC\"])"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v52 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PresentationsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Presentation",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v12/*: any*/),
          (v4/*: any*/),
          (v47/*: any*/),
          (v45/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "videoSourceUrl",
            "storageKey": null
          },
          (v48/*: any*/),
          (v49/*: any*/),
          (v50/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "transform",
                "value": {
                  "dpr": 3,
                  "h": 32,
                  "w": 32
                }
              }
            ],
            "kind": "ScalarField",
            "name": "guestPresenterAvatarUrl",
            "storageKey": "guestPresenterAvatarUrl(transform:{\"dpr\":3,\"h\":32,\"w\":32})"
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HomeScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": (v2/*: any*/),
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "UnauthenticatedHomeScreen_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HomeScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "authorizationLevel",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "presentationsCard",
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 12
          },
          (v3/*: any*/)
        ],
        "concreteType": "PresentationsConnection",
        "kind": "LinkedField",
        "name": "presentations",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PresentationsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Presentation",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "presenter",
                    "plural": false,
                    "selections": (v2/*: any*/),
                    "storageKey": null
                  },
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "presentations(first:12,orderBy:[\"CREATED_AT_DESC\",\"ID_ASC\"])"
      },
      {
        "alias": "heroImageMobile",
        "args": [
          (v6/*: any*/),
          {
            "kind": "Literal",
            "name": "transform",
            "value": {
              "dpr": 3,
              "h": 190,
              "w": 200
            }
          }
        ],
        "kind": "ScalarField",
        "name": "staticImageUrl",
        "storageKey": "staticImageUrl(path:\"home-page/event-hero.png\",transform:{\"dpr\":3,\"h\":190,\"w\":200})"
      },
      {
        "alias": "heroImageDesktop",
        "args": [
          (v6/*: any*/),
          {
            "kind": "Literal",
            "name": "transform",
            "value": {
              "dpr": 3,
              "w": 340
            }
          }
        ],
        "kind": "ScalarField",
        "name": "staticImageUrl",
        "storageKey": "staticImageUrl(path:\"home-page/event-hero.png\",transform:{\"dpr\":3,\"w\":340})"
      },
      {
        "alias": "person1",
        "args": [
          {
            "kind": "Literal",
            "name": "path",
            "value": "home-page/event-person-1.png"
          },
          (v7/*: any*/)
        ],
        "kind": "ScalarField",
        "name": "staticImageUrl",
        "storageKey": "staticImageUrl(path:\"home-page/event-person-1.png\",transform:{\"dpr\":3,\"fo\":\"face\",\"h\":80,\"w\":80})"
      },
      {
        "alias": "person2",
        "args": [
          {
            "kind": "Literal",
            "name": "path",
            "value": "home-page/event-person-2.png"
          },
          (v7/*: any*/)
        ],
        "kind": "ScalarField",
        "name": "staticImageUrl",
        "storageKey": "staticImageUrl(path:\"home-page/event-person-2.png\",transform:{\"dpr\":3,\"fo\":\"face\",\"h\":80,\"w\":80})"
      },
      {
        "alias": "person3",
        "args": [
          {
            "kind": "Literal",
            "name": "path",
            "value": "home-page/event-person-3.png"
          },
          (v7/*: any*/)
        ],
        "kind": "ScalarField",
        "name": "staticImageUrl",
        "storageKey": "staticImageUrl(path:\"home-page/event-person-3.png\",transform:{\"dpr\":3,\"fo\":\"face\",\"h\":80,\"w\":80})"
      },
      {
        "alias": "person4",
        "args": [
          {
            "kind": "Literal",
            "name": "path",
            "value": "home-page/event-person-4.png"
          },
          (v7/*: any*/)
        ],
        "kind": "ScalarField",
        "name": "staticImageUrl",
        "storageKey": "staticImageUrl(path:\"home-page/event-person-4.png\",transform:{\"dpr\":3,\"fo\":\"face\",\"h\":80,\"w\":80})"
      },
      {
        "alias": "person5",
        "args": [
          {
            "kind": "Literal",
            "name": "path",
            "value": "home-page/event-person-5.png"
          },
          (v7/*: any*/)
        ],
        "kind": "ScalarField",
        "name": "staticImageUrl",
        "storageKey": "staticImageUrl(path:\"home-page/event-person-5.png\",transform:{\"dpr\":3,\"fo\":\"face\",\"h\":80,\"w\":80})"
      },
      {
        "alias": "person6",
        "args": [
          {
            "kind": "Literal",
            "name": "path",
            "value": "home-page/event-person-6.png"
          },
          (v7/*: any*/)
        ],
        "kind": "ScalarField",
        "name": "staticImageUrl",
        "storageKey": "staticImageUrl(path:\"home-page/event-person-6.png\",transform:{\"dpr\":3,\"fo\":\"face\",\"h\":80,\"w\":80})"
      },
      {
        "alias": "avatar1",
        "args": [
          {
            "kind": "Literal",
            "name": "path",
            "value": "home-page/event-avatar-1.png"
          },
          (v7/*: any*/)
        ],
        "kind": "ScalarField",
        "name": "staticImageUrl",
        "storageKey": "staticImageUrl(path:\"home-page/event-avatar-1.png\",transform:{\"dpr\":3,\"fo\":\"face\",\"h\":80,\"w\":80})"
      },
      {
        "alias": "avatar2",
        "args": [
          {
            "kind": "Literal",
            "name": "path",
            "value": "home-page/event-avatar-2.png"
          },
          (v7/*: any*/)
        ],
        "kind": "ScalarField",
        "name": "staticImageUrl",
        "storageKey": "staticImageUrl(path:\"home-page/event-avatar-2.png\",transform:{\"dpr\":3,\"fo\":\"face\",\"h\":80,\"w\":80})"
      },
      {
        "alias": "avatar3",
        "args": [
          {
            "kind": "Literal",
            "name": "path",
            "value": "home-page/event-avatar-3.png"
          },
          (v7/*: any*/)
        ],
        "kind": "ScalarField",
        "name": "staticImageUrl",
        "storageKey": "staticImageUrl(path:\"home-page/event-avatar-3.png\",transform:{\"dpr\":3,\"fo\":\"face\",\"h\":80,\"w\":80})"
      },
      {
        "alias": "avatar4",
        "args": [
          {
            "kind": "Literal",
            "name": "path",
            "value": "home-page/event-avatar-4.png"
          },
          (v7/*: any*/)
        ],
        "kind": "ScalarField",
        "name": "staticImageUrl",
        "storageKey": "staticImageUrl(path:\"home-page/event-avatar-4.png\",transform:{\"dpr\":3,\"fo\":\"face\",\"h\":80,\"w\":80})"
      },
      {
        "alias": "avatar5",
        "args": [
          {
            "kind": "Literal",
            "name": "path",
            "value": "home-page/event-avatar-5.png"
          },
          (v7/*: any*/)
        ],
        "kind": "ScalarField",
        "name": "staticImageUrl",
        "storageKey": "staticImageUrl(path:\"home-page/event-avatar-5.png\",transform:{\"dpr\":3,\"fo\":\"face\",\"h\":80,\"w\":80})"
      },
      {
        "alias": "avatar6",
        "args": [
          {
            "kind": "Literal",
            "name": "path",
            "value": "home-page/event-avatar-6.png"
          },
          (v7/*: any*/)
        ],
        "kind": "ScalarField",
        "name": "staticImageUrl",
        "storageKey": "staticImageUrl(path:\"home-page/event-avatar-6.png\",transform:{\"dpr\":3,\"fo\":\"face\",\"h\":80,\"w\":80})"
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "highlightedGuildSlug"
          }
        ],
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodeBySlugId",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              {
                "alias": "upcomingEvents",
                "args": [
                  (v34/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "orderBy",
                    "value": [
                      "START_AT_ASC",
                      "ID_ASC"
                    ]
                  },
                  (v35/*: any*/)
                ],
                "concreteType": "EventsConnection",
                "kind": "LinkedField",
                "name": "eventsByTimeSelection",
                "plural": false,
                "selections": (v51/*: any*/),
                "storageKey": "eventsByTimeSelection(first:1,orderBy:[\"START_AT_ASC\",\"ID_ASC\"],timeSelection:\"UPCOMING\")"
              },
              {
                "alias": "pastEvents",
                "args": [
                  (v34/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "orderBy",
                    "value": [
                      "START_AT_DESC",
                      "ID_ASC"
                    ]
                  },
                  {
                    "kind": "Literal",
                    "name": "timeSelection",
                    "value": "PAST"
                  }
                ],
                "concreteType": "EventsConnection",
                "kind": "LinkedField",
                "name": "eventsByTimeSelection",
                "plural": false,
                "selections": (v51/*: any*/),
                "storageKey": "eventsByTimeSelection(first:1,orderBy:[\"START_AT_DESC\",\"ID_ASC\"],timeSelection:\"PAST\")"
              },
              {
                "alias": "upcomingPresentations",
                "args": [
                  (v34/*: any*/),
                  (v46/*: any*/),
                  (v35/*: any*/)
                ],
                "concreteType": "PresentationsConnection",
                "kind": "LinkedField",
                "name": "presentationsByEventTimeSelection",
                "plural": false,
                "selections": (v52/*: any*/),
                "storageKey": "presentationsByEventTimeSelection(first:1,orderBy:[\"CREATED_AT_ASC\",\"ID_ASC\"],timeSelection:\"UPCOMING\")"
              },
              {
                "alias": "pastPresentations",
                "args": [
                  (v34/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "timeSelection",
                    "value": "OTHER"
                  }
                ],
                "concreteType": "PresentationsConnection",
                "kind": "LinkedField",
                "name": "presentationsByEventTimeSelection",
                "plural": false,
                "selections": (v52/*: any*/),
                "storageKey": "presentationsByEventTimeSelection(first:1,orderBy:[\"CREATED_AT_DESC\",\"ID_ASC\"],timeSelection:\"OTHER\")"
              }
            ],
            "type": "Guild",
            "abstractKey": null
          },
          (v41/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 5
          },
          {
            "kind": "Literal",
            "name": "guildType",
            "value": "GUILD"
          }
        ],
        "concreteType": "GuildsConnection",
        "kind": "LinkedField",
        "name": "rankedGuilds",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GuildsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Guild",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v10/*: any*/),
                  (v21/*: any*/),
                  (v9/*: any*/),
                  (v31/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "rankedGuilds(first:5,guildType:\"GUILD\")"
      }
    ]
  },
  "params": {
    "id": "8a8bd9b4f8d1227e47fead7f36416f5a7665f2a9b83f9f1c4430df2cc6e74a88",
    "metadata": {},
    "name": "HomeScreenQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "30ef68fcc2d82c70c06a1a0ff0587ff9";

export default node;
